export default __webpack_public_path__ + "images/logo_icon.9ad98d88e79be17c7217b12ea3cc62bb.svg";